export const CAREER_LEVELS_BY_ID = {
  1: { translationKey: 'careerlevel_career_starter' },
  2: { translationKey: 'careerlevel_experienced' },
  3: { translationKey: 'careerlevel_expert' },
  4: { translationKey: 'careerlevel_leader' },
  5: { translationKey: 'careerlevel_executive' },
};
